import React, { Component, createRef } from "react";
import { Modal } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { IGetAssetsListRequest } from "../../Common/Contracts/IFacilities";
import Instense from "../../Common/Services/Axios-config";
import { Facility } from "../../Common/Services/Facility";
import { CASubType } from "../Settings/EntityManagement/CASubType";
import { CAType } from "../Settings/EntityManagement/CAType";

interface AddLocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  hidValue: number;
  updatedSelectedType: (newValue: any) => void;
  updatedSelectedSubType: (newSubValue: any) => void;
  updateLocationtypeError: (errorValue: any) => void;
  updateLocationNameError: (errorNameValue: any) => void;
  locationNameError: string;
  locationtypeError: string;
  isAddLocationLoading: boolean;
  locationDataUpdated?: () => void;
  locationList?: any
}

interface AddLocationModalState {
  locationTypes: any;
  locationSubtypes: any;
  selectedType: any;
  selectedSubtype: any;
  typeID: any;
  locationName: string;
  locationNameErrorr: string;
  isDelete: boolean;
  isGuest:boolean
  isLocationTypeDelete: boolean,
  CADetails?:any;
  locationList?: any;
}

class AddLocationModal extends Component<AddLocationModalProps, AddLocationModalState> {
  dialogRef = createRef<HTMLDialogElement>();
  constructor(props: AddLocationModalProps) {
    super(props);
    this.state = {
      locationTypes: [],
      locationSubtypes: [],
      selectedType: "",
      selectedSubtype: "",
      typeID: 0,
      locationName: "",
      locationNameErrorr: "",
      isDelete : false,
      isGuest:true,
      isLocationTypeDelete: false,
      CADetails:[],
      locationList: this.props.locationList
    };
  }

  handleDelete = (isDeleteCall : any) => {
    this.setState({ isDelete: isDeleteCall }, () => {
      if (this.state.isDelete === false) {
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    });
  };

  
  componentDidMount() {
    if (this.state?.isDelete === false) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  //tested
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement; // Assert the type
    if (target.innerText === "Select Type") {
      this.props.updateLocationtypeError("Please select a location type");
    }

    // Check if the click was outside the dialog
    if (this.props.isOpen && !this.state.isLocationTypeDelete && this.dialogRef.current && !this.dialogRef.current.contains(event.target as Node)) {

      confirmAlert({
        title: "Unsaved confirmation?",
        message:
          "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              this.props.onClose();
              this.onCloseSetState();
              // Reset the form data when closing the dialog
              this.setState({
                selectedType: "",
                // selectedSubtype: "",
                selectedSubtype : { subTypeID : null, subTypeName: ''},
                locationName: "",
                locationTypes: [],
                locationSubtypes: []
              });
            },
          },
          {
            label: "No",
            onClick: () => null
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false, // Ensure this prevents closing the confirm alert outside click
        overlayClassName: "rooms-alert",
      });
    }
  };


  getAssets = () => {
    const request: IGetAssetsListRequest = {
      searchText:'',
      hid: this.props.hidValue,
      assetTypeId:0,
    };

    Facility.GetAssets(request).then((tableData) => {
      let asssetData: any = tableData?.map((item:any) => {
        return  {id : item?.roomId, typeName: item?.roomName }
      });
      let locationData: any = this.props?.locationList?.map((item: any) => {
        return  {id : item?.roomID, typeName: item?.locationType, subTypeName: item?.roomType }
      })
      this.setState({ CADetails: [...asssetData, ...locationData] });
    });
  };

  // Fetch data when the modal opens
  componentDidUpdate(prevProps: AddLocationModalProps, prevState) {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request = {} as any;
    request.tenantid = tenantID;
    request.Hid = this.props?.hidValue;
    request.TenantID = tenantID;
    request.includeGuest = 1
    const url1 = `/EntityManagement/FacilityLocationSubTypesMasterList`;
    if (this.props.isOpen && !prevProps.isOpen) {
      this.getAssets()

      const url = `/EntityManagement/Get_FacilityType`;
      Instense.get(url, { params: request }).then((response) => {
        let result = response?.data?.result as any;
        this.setState({
          locationTypes: result
        //   locationTypes: [...result, 
        //     {
        //     typeID: 0,
        //     typeName: "Guest",
        //     tenantid: -1,
        //     createdBy: null,
        //     createdOn: null
        //   }
        // ]
        });
      });

      return Instense.get(url1, { params: request }).then((response) => {
        let result = response?.data?.result as any;
        this.setState({ locationSubtypes: result });
      });
    }
    if (prevState.isDelete !== this.state.isDelete) { 
      if (this.state.isDelete === true) {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
      else {
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    }
    if (prevProps.locationList !== this.props.locationList) {
      let locationData: any = this.props?.locationList?.map((item: any) => {
        return  {id : item?.roomID, typeName: item?.locationType, subTypeName: item?.roomType }
      })
      this.setState({ CADetails: [...this.state.CADetails, ...locationData], locationList: this.props?.locationList });
      return Instense.get(url1, { params: request }).then((response) => {
        let result = response?.data?.result as any;
        this.setState({ locationSubtypes: result });
      });
    }

  }

  handleTypeSelected = (selectedType: any) => {
    if (selectedType?.typeName == "Guest") {
      this.props.updateLocationtypeError("Note: Guest Room type cannot be changed after creation")
    } else {
      this.props.updateLocationtypeError("")
    }
    this.setState({ selectedType: selectedType.typeName, typeID: selectedType.typeID });
    this.props.updatedSelectedType(selectedType);
  };

  handleSubtypeSelected = (selectedSubtype: any) => {
    this.setState({ selectedSubtype });
    this.props.updatedSelectedSubType(selectedSubtype);
  };

  handleLocationNameChange = (event) => {
    const value = event.target.value;
    this.setState({ locationNameErrorr: "" });
    this.setState({ locationName: value });

    if (value === "") {
      // Show error message by calling a prop or setting state to indicate the error
      this.props.updateLocationNameError("Please enter a location name");
    } else {
      // Clear the error message when the input is not empty
      this.props.updateLocationNameError("");
    }
  }

  handleBlur = () => {
    const isDuplicate = this.props?.locationList.some(
      (location) => location.roomName.toLowerCase() === this.state.locationName.toLowerCase()
    );
    if(isDuplicate){
      this.setState({ locationNameErrorr: "A location with this name already exists." });
    }
    else if (this.state.locationName === "") {
      this.setState({ locationNameErrorr: "Please enter a location name" });
    } else {
      this.props.updateLocationNameError("");
    }
  };

  onCloseSetState = () => {
    this.setState({ locationNameErrorr: "" });
    this.setState({
      selectedType: "",
      // selectedSubtype: "",
      selectedSubtype : { subTypeID : null, subTypeName: ''},
      locationName: "",
      locationTypes: [],
      locationSubtypes: []
    });
  }

  render() {
    const { isOpen, onClose, onSubmit } = this.props;
    const { locationTypes, locationSubtypes, selectedType, selectedSubtype, typeID } = this.state;

    if (!isOpen) return null;

    return (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 999,
      }}>
        <dialog
          ref={this.dialogRef}
          className="addlocation-modal"
          open
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            right: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "10px",
            padding: "0",
            width: "500px",
            maxHeight: "90vh",
            overflowY: "auto",
            border: "none",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            backgroundColor: "#fff",
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <Modal.Title>Add Location</Modal.Title>
              <button type="button" className="btn-close" onClick={() => {
                onClose(); this.onCloseSetState(); this.setState({
                  selectedType: "",
                  // selectedSubtype: {},
                  selectedSubtype : { subTypeID : null, subTypeName: ''},
                  locationName: "",
                  locationTypes: [],
                  locationSubtypes: []
                });
              }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                    fill="#84888C"
                  ></path>
                </svg>
              </button>
            </div>

            <div className="modal-body">
              <form onSubmit={(e) => {
                onSubmit(e); this.setState({
                  selectedType: "",
                  // selectedSubtype: {},
                  selectedSubtype : { subTypeID : null, subTypeName: ''},
                  locationName: "",
                  locationTypes: [],
                  locationSubtypes: [],
                  typeID: 0,
                });
              }}
                style={{ position: "relative" }}>
                {this.props.isAddLocationLoading && (
                  <div className="loader-overlay">
                    <div className="loader"></div>
                  </div>
                )}
                <div style={{ opacity: this.props.isAddLocationLoading ? 0.5 : 1 }}>
                  <div className="mb-3">
                    <label className={`form-label`} style={{ fontSize: "14px", fontFamily: "OpenSans-Semibold", color: `${this.state.locationNameErrorr || this.props.locationNameError ? "#b12a18" : ""}` }}>
                      Location Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="locationName"
                      onChange={(e) => this.handleLocationNameChange(e)}
                      onBlur={this.handleBlur}
                      style={{ border: this.state.locationNameErrorr || this.props.locationNameError ? "#b12a18 1px solid" : "", fontSize: "14px", fontFamily: "OpenSans" }}
                    />
                    {this.state.locationNameErrorr ? <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.locationNameErrorr}</span> : <span className="text-danger" style={{ fontSize: "12px" }}>{this.props.locationNameError}</span>}
                  </div>
                </div>

                <div className="mb-3">
                  <label className={`form-label`} style={{ fontSize: "14px", fontFamily: "OpenSans-Semibold", color: ` ${this.props?.locationtypeError !== "" && selectedType.typeName !== "Guest" && this.props?.locationtypeError !== "Note: Guest Room type cannot be changed after creation" ? "#b12a18" : ""} ` }}>
                    Location Type <span className="text-danger">*</span>
                  </label>
                  <CAType
                    TypeList={locationTypes}
                    row={{ typeName: this.state.selectedType }}
                    typeSelected={(item, row) => this.handleTypeSelected(item)}
                    locationtypeError={this.props.locationtypeError}
                    typeNameError={selectedType}
                    isAddLocationComponent={true}
                    typeofPage={"CommonArea"}
                    isGuest={this.state.isGuest}
                    handleDelete={(value)=> this.setState({isLocationTypeDelete: value})}
                    locationDataUpdated={() => { this.props.locationDataUpdated &&  this.props.locationDataUpdated()}}
                    CADetails={this.state.CADetails}
                  />
                  {this.props?.locationtypeError == "" ? <></> : <span className="text-danger" style={{ fontSize: "12px" }}>{this.props?.locationtypeError}</span>}
                  {/* <select className="form-select form-control" name="locationType" required>
                    <option value=""></option>
                    {locationTypes?.map((type, index) => (
                      <option key={index} value={type?.typeName}>
                        {type?.typeName}
                      </option>
                    ))}
                  </select> */}
                </div>

                <div className="mb-3 subtype">
                  <label className="form-label" style={{ fontSize: "14px", fontFamily: "OpenSans-Semibold" }}>Location Subtype</label>
                  <CASubType
                    row={{ typeName: this.state.selectedType, typeID: typeID, subTypeName: this.state.selectedSubtype.subTypeName }}
                    SubTypeList={locationSubtypes}
                    subTypeSelected={this.handleSubtypeSelected}
                    isAddLocationComponent={true}
                    hotelId={this.props?.hidValue}
                    typeofPage={"CommonArea"}
                    isOpen={this.props?.isOpen}
                    handleDelete = {this.handleDelete}
                    locationDataUpdated={() => { this.props.locationDataUpdated &&  this.props.locationDataUpdated()}}
                    CADetails={this.state.CADetails}
                  />
                  {/* <select className="form-select form-control" name="locationSubtype">
                    <option value=""></option>
                    {locationSubtypes?.map((subtype, index) => (
                      <option key={index} value={subtype?.subTypeName}>
                        {subtype?.subTypeName}
                      </option>
                    ))}
                  </select> */}
                </div>

                <div className="mb-3">
                  <label className="form-label" style={{ fontSize: "14px", fontFamily: "OpenSans-Semibold" }}>Location Notes</label>
                  <textarea
                    className="form-control"
                    name="locationNotes"
                    style={{ fontSize: "14px", fontFamily: "OpenSans" }}
                  ></textarea>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={() => { onClose(); this.onCloseSetState(); }}>
                    Cancel
                  </button>
                  <button type="submit" 
                  className="btn btn-primary" 
                  disabled={
                    !this.state.locationName || 
                    !this.state.selectedType ||
                    Boolean(this.state.locationNameErrorr) ||  
                    Boolean(this.props.locationNameError)  
                  }
                  >
                    Add Location
                  </button>
                </div>
              </form>
            </div>
          </div>
        </dialog>
      </div>
    );
  }
}

export default AddLocationModal;
